import * as yup from "yup";

// $acta = new Acta();
// $acta->user_id = Auth::id();
// $acta->nombre_ciudadano = $request->nombre_ciudadano;
// $acta->dni = $request->dni;
// $acta->domicilio = $request->domicilio;
// $acta->telefono = $request->telefono;
// $acta->email = $request->email;
// $acta->tipo_id = $request->tipo_id;
// $acta->barrio_id = $request->barrio_id;
// $acta->estado_id = Estado::where('estado', 'Pendiente')->first()->id;
// $acta->ultimo_paso = 1;
// $acta->save();
// $acta = Acta::with('estado', 'barrio', 'tipo')->find($acta->id);
const allowedTypes = ["image/jpeg", "image/png", "image/jpg", "application/pdf"];
const allowedImageTypes = ["image/jpeg", "image/png", "image/jpg"];

export const schemaActaPaso1 = yup.object().shape({
  nombre_ciudadano: yup.string().required("El nombre es obligatorio"),
  dni: yup.string().required("El DNI es obligatorio"),
  telefono: yup.string().required("El teléfono es obligatorio"),
  genero: yup.string().required("Género es requerido"),
  edad: yup.string().required("Edad requerida"),
  domicilio: yup.string().required("El domicilio es obligatorio"),
  email: yup.string().email("Correo electrónico inválido").required("El correo es obligatorio"),
  // tipo_id: yup.string().required("El tipo es requerido"),
  barrio: yup.string().required("El barrio es requerido"),
  acepta_condiciones: yup.boolean().oneOf([true], "Debes aceptar los términos y condiciones"),
});

export const schemaActaPaso2 = yup.object().shape({
  lugar: yup.string().required("El lugar es requerida"),
  solicitante: yup.string().required("El solicitante es requerido"),
  descripcion: yup.string().required("La descripción es requerida"),
  files: yup
    .array()
    .of(
      yup.mixed().test("fileType", "Solo se permiten imágenes .jpeg, .jpg, .png", (file) => {
        if (!file) return false;
        return allowedImageTypes.includes(file.type);
      })
    )
    .min(1, "Debés subir al menos una imagen")
    .max(5, "Máximo 5 imágenes")
    .required("Debés subir al menos una imagen"),
  tipos_solicitud: yup
    .array()
    .min(1, "Debés seleccionar al menos un tipo de solicitud")
    .of(
      yup.object().shape({
        id: yup.number().required(),
        cantidad_arboles: yup
          .string()
          .required("Agregar")
          .test(
            "not-empty",
            "La cantidad de árboles no puede estar vacía",
            (value) => value !== ""
          ),
      })
    ),
});

export const schemaActaPaso3 = yup.object().shape({
  numero_acta: yup.string().required("N° acta es requerido"),
  observacion: yup.string().required("La observacion es requerida"),
  constatacion_dano: yup.string().required("La constatacion del daño es requerida"),
  descripcion_tarea: yup.string().required("La descripción es requerida"),
  constatacion_file: yup
    .array()
    .of(
      yup.mixed().test("fileType", "Solo se permiten archivos JPEG, PNG o PDF", (file) => {
        if (!file) return false;
        return allowedTypes.includes(file.type);
      })
    )
    .min(1, "Debés subir al menos un archivo")
    .required("El archivo es requerido"),
});

// export const schemaActaPaso3 = yup.object().shape({
//   files: yup
//     .array()
//     .min(1, "Debes subir al menos un archivo")
//     .max(5, "Máximo 5 archivos")
//     .required("Al menos un archivo")
//     .test("fileType", "Solo se permiten archivos .jpeg, .jpg, .png", (files) => {
//       if (!files || files.length === 0) return false;
//       return files.every((file) => ["image/jpeg", "image/jpg", "image/png"].includes(file.type));
//     }),
// });
